import api from '.';

export function listar({ start = 0, size = 10, filters = '[]', filtersMode = '{}', globalFilter = '', sorting = '[]' } = {}) {
    return api.get('/unidadeCondominialPessoa/listar', {
        params: {
            start,
            size,
            filters,
            filtersMode,
            globalFilter,
            sorting,
        },
    });
}

export function consultar(uuid) {
    return api.get(`/unidadeCondominialPessoa/editar/${uuid}`);
}

export function cadastrar(dados) {
    return api.post('/unidadeCondominialPessoa/cadastrar', dados);
}

export function editar(uuid, dados) {
    return api.post('/unidadeCondominialPessoa/editar', {
        ...dados,
        uuid,
    });
}

export function excluir(uuid) {
    return api.post('/unidadeCondominialPessoa/deletar', {
        id: uuid,
    });
}

export function censo({ empresaId, anoInicio, anoFim }) {
    return api.get('/unidadeCondominialPessoa/censo', {
        params: { empresaId, anoInicio, anoFim },
        responseType: 'arraybuffer',
    });
}
